"use client";

import React from "react";
import QuoteCta from "@/components/QuoteCta";
export default function GuideCta() {
  return <QuoteCta id="checkeredplateguidecta" eyebrow={{
    en: "Industrial Checkered & Anti-Slip Plate",
    zh: "工业花纹钢板与冲孔防滑板",
    de: "Industrie-Riffelblech & Rutschhemmende Platten",
    es: "Chapa lagrimada industrial y chapa antideslizante",
    fr: "Tôle larmée industrielle et tôle antidérapante",
    pt: "Chapa xadrez industrial e chapa antiderrapante"
  }} heading={{
    en: "Specify the Right Checkered Plate for Your Project",
    zh: "为您的工程项目定制花纹钢板方案",
    de: "Das passende Riffelblech für Ihr Projekt spezifizieren",
    es: "Especifique la chapa lagrimada adecuada para su proyecto",
    fr: "Spécifiez la tôle larmée adaptée à votre projet",
    pt: "Especifique a chapa xadrez certa para o seu projeto"
  }} body={{
    en: "Send your drawings, bill of materials, or technical specifications. Our team will review your requirements and prepare a quotation; processing options can be coordinated upon request. Quote timing is confirmed per project.",
    zh: "欢迎发送您的建筑设计图纸、下料清单或技术要求。我们的团队将认真评估并提供报价；图纸审核与配套定制加工方案可按需协调。报价时间根据每个项目具体确认。",
    de: "Senden Sie Ihre Zeichnungen, Stücklisten oder technischen Vorgaben. Unser Team prüft Ihre Anforderungen und erstellt ein Angebot; Bearbeitungsoptionen können auf Anfrage koordiniert werden. Die Angebotsdauer wird projektbezogen bestätigt.",
    es: "Envíe sus planos, lista de materiales o especificaciones técnicas. Nuestro equipo evaluará sus requisitos y preparará una cotización; las opciones de procesado se pueden coordinar a petición. El plazo de cotización se confirma según el proyecto.",
    fr: "Envoyez vos plans, nomenclatures ou spécifications techniques. Notre équipe examinera vos exigences et établira un devis ; les options d'usinage peuvent être coordonnées sur demande. Le délai de remise de devis est confirmé selon le projet.",
    pt: "Envie seus desenhos, lista de materiais ou especificações técnicas. Nossa equipe analisará seus requisitos e elaborará uma cotação; opções de processamento podem ser coordenadas mediante solicitação. O prazo de cotação é confirmado conforme o projeto."
  }} primaryButton={{
    label: {
      en: "Request a quote",
      zh: "索取报价",
      de: "Angebot anfordern",
      es: "Solicitar cotización",
      fr: "Demander un devis",
      pt: "Solicitar cotação"
    },
    to: "/ContactPage"
  }} secondaryButton={{
    label: {
      en: "View Checkered Plate",
      zh: "查看花纹钢板产品",
      de: "Riffelblech ansehen",
      es: "Ver chapa lagrimada",
      fr: "Voir la tôle larmée",
      pt: "Ver chapa xadrez"
    },
    to: "/CheckeredPlatePage"
  }} />;
}